import React from 'react';

import { Card, Box, DividerLine, Skeleton, Typography } from '@bcp-nextgen-dx-component-factory/design-system';
import { IconTooltip } from '@components';
import { rem } from '@helpers';

import { CorporateFormProps } from '../../corporateData.helper';
import { useCorporateFormSkeletonHelper } from './corporateFormSkeleton.helper';

export const CorporateFormSkeleton: React.FC<CorporateFormProps> = ({ title, pagePadding }) => {
	const { resources } = useCorporateFormSkeletonHelper();

	return (
		<Box styles={{ flexDirection: 'column' }}>
			<Box styles={{ flexDirection: 'column', padding: pagePadding }}>
				<Typography appearance="headline-200-02">{title}</Typography>

				{/** Online Shop */}
				<Box styles={{ flexDirection: 'column', gap: rem(16) }}>
					<Box styles={{ gap: rem(8), marginTop: rem(40) }}>
						<Typography appearance="subtitle-100-03">{resources.onlineShop}</Typography>
						<IconTooltip tooltip={{ label: resources.tooltipOnlineShop }} />
					</Box>
					<Card.Base width={'100%'}>
						<Box styles={{ width: '100%', marginBottom: rem(8), gap: rem(10) }}>
							<Skeleton variant={'light'} width={'50%'} height={50} borderRadius={8} />
							<Skeleton variant={'light'} width={'50%'} height={50} borderRadius={8} />
						</Box>
					</Card.Base>
				</Box>

				{/** Contacts */}
				<Box styles={{ marginTop: rem(32), marginBottom: rem(16) }}>
					<Typography appearance="subtitle-100-03">{resources.contacts}</Typography>
				</Box>
				<Card.Base width={'100%'}>
					<Box styles={{ flexDirection: 'column', width: '100%' }}>
						{/* Corporate */}
						<Typography appearance="body-100-03">{resources.corporate}</Typography>
						<Box styles={{ marginTop: rem(16), gap: rem(10) }}>
							<Box styles={{ width: '50%', marginBottom: rem(8) }}>
								<Skeleton variant={'light'} width={'100%'} height={50} borderRadius={8} />
							</Box>
							<Box styles={{ width: '50%', marginBottom: rem(8), gap: rem(10) }}>
								<Skeleton variant={'light'} width={'20%'} height={50} borderRadius={8} />
								<Skeleton variant={'light'} width={'80%'} height={50} borderRadius={8} />
							</Box>
						</Box>

						<DividerLine margin={'1.5rem 0'} />

						{/** Manager */}
						<Box styles={{ gap: rem(8) }}>
							<Typography appearance="body-100-03">{resources.manager}</Typography>
							<IconTooltip tooltip={{ label: resources.tooltipManager }} />
						</Box>

						<Skeleton margin={'1rem 0'} variant={'light'} width={'49.5%'} height={50} borderRadius={8} />

						<Box styles={{ marginTop: rem(16), gap: rem(10) }}>
							<Box styles={{ width: '50%', marginBottom: rem(8) }}>
								<Skeleton variant={'light'} width={'100%'} height={50} borderRadius={8} />
							</Box>
							<Box styles={{ width: '50%', marginBottom: rem(8), gap: rem(10) }}>
								<Skeleton variant={'light'} width={'20%'} height={50} borderRadius={8} />
								<Skeleton variant={'light'} width={'80%'} height={50} borderRadius={8} />
							</Box>
						</Box>
					</Box>
				</Card.Base>
			</Box>
		</Box>
	);
};
